export const manifestLocales = {
  submitPageReturnToFixSwitch: {
    previewImageAlt: {
      en: 'Submit Page Return To Fix Switch',
      he: 'החזרה לתיקון'
    }
  }
};
